export const spacer = `<div class="spacer xs border-dark"></div>
<div class="spacer sm border-dark"></div>
<div class="spacer md border-dark"></div>
<div class="spacer lg border-dark"></div>
<div class="spacer xl border-dark"></div>
<div class="spacer xxl border-dark"></div>`